


































































































import {Component, Watch} from 'vue-property-decorator';
import IntegrationsApi from  '@/services/rest/bemob/integrations';

import {mixins} from 'vue-class-component';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class CustomIntegrations extends mixins<PlanLimitsMixin,IntegrationMixin>(PlanLimitsMixin,IntegrationMixin) {
  integrationsApi: IntegrationsApi = new IntegrationsApi();
  checkingStatusId: string = '';
  rowsOnPage: number = 10;
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  get headers() {
    return [
      {
        text: this.t('Integration Name'),
        align: 'left',
        value: 'name',
        sortable: true
      },
      {
        text: this.t('Network'),
        align: 'left',
        value: 'type',
        sortable: true
      },
      {
        text: this.t('Status'),
        align: 'left',
        value: 'status',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        value: 'status',
        sortable: false
      }
    ]
  }

  chooseNewIntegration() {
    this.bus.emit('open-dialog', { name: 'ChooseIntegrationDialog', data: { createIntegrationOpen: this.createIntegrationOpen } });
  }

  updateStatus(item:any) {
    const {id} = item;
    this.checkingStatusId = id;

    this.integrationsApi.checkStatus(id)
      .then((data)=>this.$store.commit('updateIntegrationsCache',data))
      .catch((err)=>this.$store.commit('updateIntegrationsCache', err.response.data.payload))
      .finally(()=>{
        this.checkingStatusId = '';
      })
  }

  createIntegrationOpen(data:any) {
    if(data.type==='facebook-conversions'){
      return this.bus.emit('open-dialog', { name: 'CreateIntegrationDialogFacebook', data });
    }
    this.bus.emit('open-dialog', { name: 'CreateIntegrationDialog', data });
  }

  async mounted() {
    this.$store.commit('loading', true);

    if(!this.$store.state.cache.integrations.isUploaded){
      await this.integrationsApi.populateStoreCache()
    }
  }

  deleteIntegration(id:string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('Removing the integrated element will end automatic cost passing for all the associated campaigns. Previously collected cost data will not be deleted.'),
      onConfirm: () => {
        this.integrationsApi.delete(id)
          .then(() => {
          })
          .finally(() => {
            this.$emit('close');
          });
      }
    }})
  }

  editIntegration(data) {
    if(data.type==='facebook-conversions'){
      return this.bus.emit('open-dialog', { name: 'CreateIntegrationDialogFacebook', data });
    }
    this.bus.emit('open-dialog', { name: 'CreateIntegrationDialog', data });
  }

  getStatus(integration) {
    if(this.hasPlanLimitsRestriction(integration.planLimits)){
      return this.t('Access Limited')
    }
    
    if(integration.status ==='active'){
      return this.t('active')
    }
    return integration.statusMessage
  }

  get tableRows() {
    return this.$store.state.cache.integrations.data.map(item=>({
        ...item,
        planLimits: this.integrationsPlanLimits(item.type)
      })
    );
  }

}
